import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { UploadProgress, UploadState } from './upload-dialog-base';

@Component({
    selector: 'upload-progress',
    template: require('./upload-progress.component.html'),
    styles: [require('./upload-progress.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UploadProgressComponent {
    @Input()
    public set uploadProgress(value: UploadProgress) {
        if (value) {
            this.percentDone = Math.round(100 * value.loaded / value.total);
        } else {
            this.percentDone = 0;
        }
    }

    @Input()
    public uploadState: UploadState;

    @Input()
    public uploadError: string;

    public get successUpload(): boolean {
        return this.uploadState === UploadState.SuccessUpload;
    }

    public get inProgress(): boolean {
        return this.uploadState === UploadState.inProgress;
    }

    public get errorUpload(): boolean {
        return this.uploadState === UploadState.ErrorUpload;
    }

    public get invalidFiles(): boolean {
        return this.uploadState === UploadState.InvalidFiles;
    }  

    public get invalidMetadata(): boolean {
        return this.uploadState === UploadState.InvalidMetadata;
    }  

    public get missingDocumentFolder(): boolean {
        return this.uploadState === UploadState.MissingDocumentFolder;
    }

    public percentDone = 0;
}
